import React from 'react';
import classNames from 'classnames';
import { TextareaStyled } from './styled';

const TextareaField = ({ className, ...props } : any) => (
  <TextareaStyled className={classNames(className, 'rounded')} {...props} />
);

export default TextareaField;
